import { render, staticRenderFns } from "./theme-configuration.vue?vue&type=template&id=22365ef5&scoped=true&"
import script from "./theme-configuration.vue?vue&type=script&lang=js&"
export * from "./theme-configuration.vue?vue&type=script&lang=js&"
import style0 from "./theme-configuration.vue?vue&type=style&index=0&id=22365ef5&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22365ef5",
  null
  
)

export default component.exports